import React, {
  Component,
  PureComponent
} from 'react';
import { BkmsInfo }               from "../../../store/API/types";
import { BookmarkExportFormType } from "../../../store/bookmarks/types";
import { chooseService }          from "../../../utils";
import BkmFormCreateComponent     from "../../bookmarks/BkmFormCreateComponent";
import BkmFormDeleteComponent     from '../../bookmarks/BkmFormDeleteComponent';
import BkmFormForExportComponent  from "../../bookmarks/BkmFormForExportComponent";
import BkmFormUpdateComponent     from "../../bookmarks/BkmFormUpdateComponent";
import ExportApplyButtons         from "../../reusable/ApplyButtons";

import CloseIconComponent        from "../../reusable/CloseIconComponent";
import ExportDatePickerComponent from "../ExportDatePickerComponent";
import ExportModeButtons         from "../ExportModeButtons";
import ExportWarningComponent    from "../ExportWarningComponent";
import './style.scss';

interface IProps {
  closeHandler: () => void,
  applyExport: (data: BookmarkExportFormType) => void,
  triggerMode: (mode: string) => void,
  mode: string,
  onChangeEndTime: (time: any) => void,
  onChangeStartTime: (time: any) => void,
  onChangeCayugaTime: (time: any) => void,
  timelineTime: number,
  startTime: Date | null,
  endTime: Date | null,
  warningMessage: string[],
  bkmsInfo: BkmsInfo,
  title: string
}

interface IState {
  [propName: string]: string
}

// TODO
// 1) Rewrite to functional component ??
// 2) Split logic for ocularis/cayuga ??

class DoExportComponent extends PureComponent<IProps, IState> {

  state = {
    tags: '',
    comments: '',
    classification: 'False',
    caseName: '--Case--',
    name: '',
    description: ''
  };

  componentDidMount() {
    if (!this.props.startTime && !this.props.endTime) {
      chooseService(
        () => {
          this.props.onChangeStartTime(new Date(
            new Date(this.props.timelineTime)
              .setMinutes(
                new Date(this.props.timelineTime).getMinutes() - 10
              )
            )
          );
          this.props.onChangeEndTime(this.props.timelineTime);
        },
        () => {
          this.props.onChangeCayugaTime(this.props.timelineTime);
        }
      )

    }
  }

  onChange = (name: string, value: string) => {
    this.setState({
      [name]: value
    })
  };

  modifiedApplyExport = () => {
    this.props.applyExport({...this.state});
    this.props.closeHandler();
  };

  render() {
    const {
      closeHandler,
      onChangeStartTime,
      onChangeEndTime,
      onChangeCayugaTime,
      triggerMode,
      startTime,
      endTime,
      mode,
      warningMessage,
      title,
      bkmsInfo
    } = this.props;

    return (
      <div className='exports'>
        <div className='exports-title'>Export
          <CloseIconComponent handler={closeHandler}/>
        </div>
        <div className='exports-content'>
          <ExportModeButtons mode={mode}
                             triggerMode={triggerMode}
          />
          {
            title && <h2 className='exports__camera-title'>
              {title}
            </h2>
          }

          {
            (mode === 'avi' || mode === 'bookmarks') && <div className='export-buttons-container'>
              <div className='w-100 flex js-c pos-rel'>
                <ExportDatePickerComponent
                  time={startTime}
                  onChangeTime={onChangeStartTime}
                  title={'Start'}
                />
              </div>
              <div className='w-100 flex js-c pos-rel'>
                <ExportDatePickerComponent
                  time={endTime}
                  onChangeTime={onChangeEndTime}
                  title={'End'}
                />
              </div>
            </div>
          }
          {
            mode === 'createBookmark' && <div className='export-buttons-container'>
              <div className='w-100 flex js-c pos-rel'>
                <ExportDatePickerComponent
                  time={startTime}
                  onChangeTime={onChangeCayugaTime}
                  title={'Bookmark Time'}
                />
              </div>
            </div>
          }

          <ExportWarningComponent
            messages={warningMessage}/>

          {
            (mode === 'bookmarks' && bkmsInfo) && <div>
              <BkmFormForExportComponent
                tags={this.state.tags}
                comments={this.state.comments}
                classifications={bkmsInfo.classifications}
                classification={this.state.classification}
                cases={bkmsInfo.cases}
                caseName={this.state.caseName}
                onChange={this.onChange}
              />
            </div>
          }
          {
            (mode === 'createBookmark') && <BkmFormCreateComponent
              name={this.state.name}
              description={this.state.description}
              onChange={this.onChange}
            />
          }
          {
            (mode === 'deleteBookmark') && <BkmFormDeleteComponent
              onChangeTime={onChangeCayugaTime}
            />
          }
          {
            (mode === 'updateBookmark') && <BkmFormUpdateComponent
              onChange={this.onChange}
              name={this.state.name}
              description={this.state.description}
              onChangeTime={onChangeCayugaTime}
            />
          }

          <ExportApplyButtons
            disable={!!warningMessage.length}
            cancelHandler={closeHandler}
            OKHandler={this.modifiedApplyExport}
          />
        </div>
      </div>
    )
  }

}


export default DoExportComponent